import { render, staticRenderFns } from "./InputCoordsList.vue?vue&type=template&id=13900583&lang=pug"
import script from "./InputCoordsList.vue?vue&type=script&lang=js"
export * from "./InputCoordsList.vue?vue&type=script&lang=js"
import style0 from "./InputCoordsList.vue?vue&type=style&index=0&id=13900583&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports